import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished } from "@itk/typescript-utils";
import { CountryGet } from "./countries-types";

export enum Action {
  GetCountriesRequest = "@@ITK:SRC:COMPONENTS:COUNTRIES:COUNTRIES-STORE.TS:ACTION:GETCOUNTRIESREQUEST",
  GetCountriesSuccess = "@@ITK:SRC:COMPONENTS:COUNTRIES:COUNTRIES-STORE.TS:ACTION:GETCOUNTRIESSUCCESS",
  GetCountriesCacheRequest = "@@ITK:SRC:COMPONENTS:COUNTRIES:COUNTRIES-STORE.TS:ACTION:GETCOUNTRIESCACHEREQUEST"
}

type CountryState = {
  countriesLoading: Loading<CountryGet[]>;
};

const initialState: CountryState = {
  countriesLoading: loadingNotStarted
};

export const countriesActions = {
  getCountriesRequest: () => actionCreator(Action.GetCountriesRequest),
  getCountriesSuccess: (data: CountryGet[]) => actionCreator(Action.GetCountriesSuccess, { data }),
  getCountriesCacheRequest: () => actionCreator(Action.GetCountriesCacheRequest)
};

export const countriesReducer = (state = initialState, action: ActionReturnType<typeof countriesActions>): CountryState => {
  switch (action.type) {
    case Action.GetCountriesRequest:
      return { ...state, countriesLoading: loadingIsLoading };
    case Action.GetCountriesSuccess:
      return { ...state, countriesLoading: loadingFinished(action.payload.data) };
    default:
      return state;
  }
};
